import { apiManager } from "../api-manager";

export const getOrders = async (
  limit = 10,
  sort = "desc",
  page = 1,
  fromdate: any,
  todate: any,
  users: any,
  brands: any,
  drivers: any,
  createdago: any,
  status: any
) => {
  let res = await apiManager.get("/admin/order/all", {
    params: {
      limit,
      sort,
      page,
      fromdate,
      todate,
      users,
      brands,
      drivers,
      createdago,
      status,
    },
  });
  return res;
};
